import '@rhtml/operators';

import { LoggedInGuard } from '@app/app.guards';
import { AppState } from '@app/app.state';
import { CoreModule } from '@app/core/core.module';
import { FooterComponent } from '@app/footer/footer.component';
import { HomeComponent } from '@app/home/home.component';
import { LoginComponent } from '@app/login/login.component';
import { SocialComponent } from '@app/login/social/social.component';
import { NavbarComponent } from '@app/navbar/navbar.component';
import { ResetPasswordComponent } from '@app/reset-password/reset-password.component';
import { RootComponent } from '@app/root/root.component';
import { palettes } from '@app/shared/palettes';
import { SignUpComponent } from '@app/signin/signin.component';
import { Module } from '@rxdi/core';
import { HotkeyModule } from '@rxdi/hotkeys';
import { RouterModule } from '@rxdi/router';
import { ReactiveUiModule } from '@rxdi/ui-kit';
import { LoadingComponent } from '@rxdi/ui-kit/loading';
import { SharedModule } from '@shared/shared.module';

import { AppComponent } from './app.component';
import { SuccessMagicLinkComponent } from './signin/success-magic-link';

@Module({
  components: [
    NavbarComponent,
    HomeComponent,
    FooterComponent,
    LoginComponent,
    SocialComponent,
    SignUpComponent,
    ResetPasswordComponent,
    LoadingComponent,
  ],
  imports: [
    HotkeyModule.forRoot(),
    ReactiveUiModule.forRoot({
      palettes,
    }),

    SharedModule,
    CoreModule,
    RouterModule.forRoot<string>(
      [
        {
          path: '/',
          component: RootComponent,
          animate: true,
        },
        {
          path: '/about',
          component: HomeComponent,
          animate: true,
        },
        {
          path: '/admin',
          animate: true,
          children: () => import('./admin/admin.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/login',
          component: LoginComponent,
        },
        {
          path: '/signup',
          component: SignUpComponent,
        },
        {
          path: '/signup/success/:email',
          component: SuccessMagicLinkComponent,
        },
        {
          path: '/ui-components',
          children: () => import('./ui-components/ui-components.module'),
        },
        {
          path: '/roadmap',
          children: () => import('./roadmap/roadmap.module'),
        },
        {
          path: '/documentation',
          children: () => import('./documentation/documentation.module'),
        },
        {
          path: '/release-notes',
          children: () => import('./release-notes/release-notes.module'),
        },
        {
          path: '/reset-password',
          component: ResetPasswordComponent,
        },
        {
          path: '/projects',
          children: () => import('./projects/projects.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/profile',
          children: () => import('./profile/profile.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/pricing',
          animate: true,
          children: () => import('./pricing/pricing.module'),
        },
        {
          path: '/teams',
          children: () => import('./teams/teams.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/apps',
          children: () => import('./apps/apps.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/auth',
          children: () => import('./auth/auth.module'),
        },
        {
          path: '/instances',
          children: () => import('./instances/instances.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/cards',
          children: () => import('./cards/cards.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/iot',
          children: () => import('./iot/iot.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/image-view',
          children: () => import('./image-view/image-view.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '/payments',
          children: () => import('./payments/payments.module'),
          canActivate: LoggedInGuard,
        },
        {
          path: '(.*)',
          animate: true,
          component: 'not-found-component',
          action: () => import('./not-found/not-found.component'),
        },
      ],
      { log: false }
    ),
  ],
  providers: [AppState],
  bootstrap: [AppComponent],
})
export class AppModule {}
